module.exports = __webpack_public_path__ + "5c7db274b29d9f2450829598b56a9158.MP3";